import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import { IconWithTooltip } from '__pages/Common/components/LinkWithIconTooltip/IconWithTooltip';
import { useTranslation } from 'react-i18next';
import { Bar } from './Bar';

type StatisticRowProps = {
  percentage: number;
  used: number;
  limit: number;
  label: string;
  info?: string;
  divisions?: {
    risk?: number;
    over?: number;
  };
  small?: boolean;
  color?: string;
};

export const StatisticRow = (props: StatisticRowProps) => {
  const { percentage, used, limit, label, info, divisions, small, color } =
    props;
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex items-center gap-x-5">
          <Typography size={small ? 'sm' : 'md'}>{label}</Typography>
          {info ? <IconWithTooltip label={info} /> : null}
        </div>
        <Typography size={small ? 'sm' : 'md'}>
          {used.toLocaleString()}/
          {limit === Infinity ? t('unlimited') : limit.toLocaleString()}
        </Typography>
      </div>
      <Spacer size={10} />
      <div className="flex gap-x-5 w-full">
        <Bar percentage={percentage} divisions={divisions} color={color} />
      </div>
    </div>
  );
};
